





























































































import { Component, Vue, Watch } from "vue-property-decorator";
import { selectAddressPanel,logoutPanel1 } from "@/components";
import { TbShop } from '@/http';
import { Toast } from 'vant';
@Component({
  components: {
    selectAddressPanel,logoutPanel1
  },
})
export default class storeInfo extends Vue {

    public $refs: {};
    //  用户信息
    userInfo = {}

    //个人数据
    form = {};
    oldForm = {};
    addressName="";

    isEdit = false;
    btnloading = false;

    /**提示弹窗 */
    tipShow = false;
    tipTitle ="";
    tipText="";
    confirmText="";
    cancelText="";
    btnNums=1;
    tipType=1;

    bqcheck = false;
    
    created() {
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
    }
    async mounted(){
        await this.getshopInfo();
    }
    async getshopInfo(){
        let resShop = await TbShop.GetTbShopById({id:this.userInfo['shopId']});
        this.form = resShop;
        this.oldForm = Object.assign({},resShop);
        if(this.form){
            this.addressName = this.form['province']?this.form['province']+this.form['city']+this.form['area']:'';
        }
        console.log('this.form',this.form);
    }
    showAddress(){
        this.$refs['selectAddressPanel'].showFun();
    }
    onConfirmAddress(value){
        let arr= JSON.parse(value);
        this.form['province'] = arr[0];
        this.form['city'] = arr[1];
        this.form['area'] = arr[2];
        this.addressName = this.form['province']+this.form['city']+this.form['area'];
    }
    //编辑门店信息
    editInfo(){
        this.isEdit = true;
    }
    async cancelInfo(){
        this.isEdit = false;
        await this.getshopInfo();
    }
    //保存门店信息
    async confirmInfo(){
        if(!this.form['shopName']) {
            Toast('请输入门店名称');
            return;
        }
        if(!this.form['name']) {
            Toast('请输入联系人');
            return;
        }
        if(this.btnloading) return;
        try{
            this.btnloading = true;
            let obj = {
                id:this.form['id'],
                shopName:this.form['shopName'],
                name:this.form['name'],
                businessCategoryCode:this.form['businessCategoryCode'],
                businessCategoryName:this.form['businessCategoryName'],
                province:this.form['province'],
                city:this.form['city'],
                area:this.form['area'],
                address:this.form['address']
            }
            console.log(obj);
            let oldobj = this.oldForm;
            let res = await TbShop.PutShopInfo(obj);
            Toast('店铺信息设置成功');
            this.cancelInfo();
            this.btnloading = false;
            if(this.judgeBc(obj,oldobj)){
                this.tipTitle = "保存提醒";
                this.tipText = `商品标签、销售订单小票是否使用更改后的门店信息？`;
                this.btnNums=2;
                this.confirmText = "确认";
                this.cancelText = "取消"
                this.tipType = 1;
                this.$nextTick(()=>{
                    this.tipShow = true;
                })
            }
        }catch {
            this.btnloading = false;
        }
    }
    judgeBc(val,oldval){
        let flag = true;
        let flag1 = val.shopName == oldval['shopName'];
        let flag2 = val.name == oldval['name'];
        let flag3 = val.province == oldval['province'];
        let flag4 = val.city == oldval['city'];
        let flag5 = val.area == oldval['area'];
        let flag6 = val.address == oldval['address'];
        if(flag1&&flag2&&flag3&&flag4&&flag5&&flag6){
            flag = false;
        }
        return flag;
    }
    /**提示弹窗 */
    async tipConfirm(val){
        switch (this.tipType) {
            case 1:
                console.log('val',val);
                if(val.val1 || val.val2){
                    let obj = {
                        id:this.form['id'],
                        shopName:this.form['shopName'],
                        name:this.form['name'],
                        businessCategoryCode:this.form['businessCategoryCode'],
                        businessCategoryName:this.form['businessCategoryName'],
                        province:this.form['province'],
                        city:this.form['city'],
                        area:this.form['area'],
                        address:this.form['address'],
                        lab:val.val1,
                        ticket:val.val2,
                    }
                    console.log(obj);
                    let res = await TbShop.PutShopInfo(obj);
                    Toast('保存成功');
                }
                break;
            default:
                break;
        }
        this.tipShow = false;
    }
    tipCancel(){
        this.tipShow = false;
    }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/setting/components/storeInfo.vue